import React, { useState, useEffect } from "react";
import "./Transactions.css";

const Transactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
    status: "",
    search: "",
  });

  useEffect(() => {
    fetchTransactions();
  }, []);

  useEffect(() => {
    handleFilter();
  }, [filters, transactions]);

  const fetchTransactions = () => {
    // Dummy transaction data
    const dummyData = [
      {
        id: "TXN1001",
        requesterName: "John Doe",
        amount: 120.5,
        date: "2025-08-10",
        status: "Paid",
        method: "Credit Card",
      },
      {
        id: "TXN1002",
        requesterName: "Jane Smith",
        amount: 200,
        date: "2025-08-08",
        status: "Pending",
        method: "PayPal",
      },
      {
        id: "TXN1003",
        requesterName: "Robert Brown",
        amount: 75.99,
        date: "2025-08-05",
        status: "Failed",
        method: "Debit Card",
      },
      {
        id: "TXN1004",
        requesterName: "Emily Johnson",
        amount: 350,
        date: "2025-07-30",
        status: "Paid",
        method: "Bank Transfer",
      },
      {
        id: "TXN1005",
        requesterName: "Michael Lee",
        amount: 499.99,
        date: "2025-07-28",
        status: "Paid",
        method: "Credit Card",
      },
      {
        id: "TXN1006",
        requesterName: "Sophia Taylor",
        amount: 145.75,
        date: "2025-07-25",
        status: "Pending",
        method: "PayPal",
      },
      {
        id: "TXN1007",
        requesterName: "David Miller",
        amount: 220,
        date: "2025-07-22",
        status: "Failed",
        method: "Credit Card",
      },
      {
        id: "TXN1008",
        requesterName: "Olivia Wilson",
        amount: 89.5,
        date: "2025-07-20",
        status: "Paid",
        method: "Bank Transfer",
      },
    ];
    setTransactions(dummyData);
  };

  const handleFilter = () => {
    let filtered = [...transactions];

    // Date filters
    if (filters.dateFrom) {
      filtered = filtered.filter(
        (t) => new Date(t.date) >= new Date(filters.dateFrom)
      );
    }
    if (filters.dateTo) {
      filtered = filtered.filter(
        (t) => new Date(t.date) <= new Date(filters.dateTo)
      );
    }

    // Status filter
    if (filters.status) {
      filtered = filtered.filter((t) => t.status === filters.status);
    }

    // Search filter
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      filtered = filtered.filter(
        (t) =>
          t.id.toLowerCase().includes(searchLower) ||
          t.requesterName.toLowerCase().includes(searchLower)
      );
    }

    setFilteredTransactions(filtered);
  };

  return (
    <div className="transactions-main-container">
      <h2>Transactions</h2>

      {/* Summary Cards */}
      <div className="transactions-summary">
        <div className="summary-card">
          <span className="label">Total Transactions</span>
          <span className="value">
            ${transactions.reduce((sum, t) => sum + t.amount, 0).toFixed(2)}
          </span>
        </div>
        <div className="summary-card">
          <span className="label">Pending</span>
          <span className="value">
            {transactions.filter((t) => t.status === "Pending").length}
          </span>
        </div>
        <div className="summary-card">
          <span className="label">Completed</span>
          <span className="value">
            {transactions.filter((t) => t.status === "Paid").length}
          </span>
        </div>
        <div className="summary-card">
          <span className="label">Failed</span>
          <span className="value">
            {transactions.filter((t) => t.status === "Failed").length}
          </span>
        </div>
      </div>

      {/* Filters */}
      <div className="transactions-actions">
        <input
          type="text"
          placeholder="Search by ID or Client..."
          value={filters.search}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, search: e.target.value }))
          }
        />
        <input
          type="date"
          value={filters.dateFrom}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, dateFrom: e.target.value }))
          }
        />
        <input
          type="date"
          value={filters.dateTo}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, dateTo: e.target.value }))
          }
        />
        <select
          value={filters.status}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, status: e.target.value }))
          }
        >
          <option value="">All Status</option>
          <option value="Paid">Paid</option>
          <option value="Pending">Pending</option>
          <option value="Failed">Failed</option>
        </select>
      </div>

      {/* Table */}
      <div className="arq-table-container">
        <table className="arq-styled-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Client</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Status</th>
              <th>Method</th>
            </tr>
          </thead>
          <tbody>
            {filteredTransactions.length > 0 ? (
              filteredTransactions.map((t) => (
                <tr key={t.id}>
                  <td>{t.id}</td>
                  <td>{t.requesterName}</td>
                  <td>${t.amount.toFixed(2)}</td>
                  <td>{t.date}</td>
                  <td>
                    <span
                      className={`badge ${
                        t.status.toLowerCase() === "paid"
                          ? "completed"
                          : t.status.toLowerCase() === "pending"
                          ? "pending"
                          : "failed"
                      }`}
                    >
                      {t.status}
                    </span>
                  </td>
                  <td>{t.method}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No transactions found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Transactions;
